module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "exerciseBox box",
    class: [_vm.startToggle, {
      'box-success': _vm.correctExercise
    }, {
      'box-danger': _vm.isIncorrect && !_vm.hasEssayQuestion
    }],
    attrs: {
      "name": _vm.fullExercise.identifier
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(!_vm.examExercise) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$options.filters.pickTranslation(_vm.fullExercise.title) || _vm.$t("pages.exercise.name") + " " + (_vm.examResults ? _vm.fullExercise.id : _vm.fullExercise.identifier)) + "\n        "), (!_vm.examExercise) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInfoModal(_vm.fullExercise)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]) : _vm._e()]) : _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pages.exercise.name") + " " + (_vm.index + 1) + (_vm.exercisesNumber ? " / " + _vm.exercisesNumber : "")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [(_vm.subgroupExercise && _vm.subgroupExercise.exercise && _vm.subgroupExercise.exercise.currentRating) ? _c('span', {
    staticClass: "hidden-xs text-muted"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pages.exercise.rating")) + ": " + _vm._s(_vm.subgroupExercise.exercise.currentRating) + "\n        ")]) : (_vm.examResults) ? _c('span', {
    staticClass: "hidden-xs text-muted"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pages.exercise.rating")) + ": " + _vm._s(_vm.examExercise.rating) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showReportModal(_vm.fullExercise)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-box-tool dropdown-toggle",
    attrs: {
      "type": "button"
    }
  }, [(_vm.correctExercise) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00a65a"
    }
  }) : (_vm.isIncorrect && !_vm.hasEssayQuestion) ? _c('i', {
    staticClass: "fa fa-times text-red",
    staticStyle: {
      "color": "#f56954"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.startToggle) ? _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleColapsedBox()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleColapsedBox()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('exercise', {
    attrs: {
      "subgroupExercise": _vm.subgroupExercise,
      "examExercise": _vm.examExercise
    }
  })], 1)]), _vm._v(" "), (_vm.showReportModalBoolean) ? _c('div', {
    staticClass: "modal modal-danger fade",
    attrs: {
      "name": _vm.fullExercise.exerciseVersionId,
      "id": _vm.modalReportKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.report')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportBody),
      expression: "reportBody"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.reportBody)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportBody = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reportExercise($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.save')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showSuccessReportModalBoolean) ? _c('div', {
    staticClass: "modal modal-success fade",
    attrs: {
      "name": _vm.fullExercise.exerciseVersionId,
      "id": _vm.alertReportSuccessfulKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.reportSuccessful')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal modal-danger fade",
    attrs: {
      "id": "modal-erase"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.deleteP')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))])])])])]), _vm._v(" "), (_vm.showInfoModalBoolean) ? _c('div', {
    staticClass: "modal modal-success fade",
    attrs: {
      "id": _vm.modalInfoKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.info')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exercise.modalInfoId')) + ": " + _vm._s(_vm.fullExercise.identifier))]), _vm._v(" "), (_vm.fullExercise.author) ? _c('p', [_vm._v(_vm._s(_vm.$t('pages.exercise.modalInfoAuthor')) + ": " + _vm._s(_vm.fullExercise.author))]) : _vm._e(), _vm._v(" "), (_vm.adminView && _vm.fullExercise.tags) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('pages.exercise.modalInfoTags')) + ":\n            "), _vm._l((_vm.fullExercise.tags), function(tag) {
    return _c('span', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-left": "3pt"
      }
    }, [_vm._v(_vm._s(tag))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.adminView && _vm.fullExercise.source) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('pages.exercise.modalInfoSource')) + ": " + _vm._s(_vm.fullExercise.source) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.subgroupExercise && _vm.subgroupExercise.exercise && _vm.subgroupExercise.exercise.currentRating) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t("pages.exercise.rating")) + ": " + _vm._s(_vm.subgroupExercise.exercise.currentRating) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34720fbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34720fbf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/Exercises.vue
// module id = 1396
// module chunks = 1